import {
  SearchExamCenterLocationsUsageDocument,
  SearchExamCenterRoomsDocument,
  useRevokeExamCenterLocationByIdMutation,
} from '@exam-center/graphql';
import { useCallback } from 'react';

interface RevokeExamCenterLocationPermissionInput {
  examCenterLocationId: string;
  remark: string;
}
export function useRevokeExamCenterLocationPermission() {
  const [revokeExamCenterLocationById, { loading: revokeLoading, error }] =
    useRevokeExamCenterLocationByIdMutation();

  const revoke = useCallback(
    async (input: RevokeExamCenterLocationPermissionInput) => {
      await revokeExamCenterLocationById({
        variables: {
          revokeExamCenterLocationByIdInput: {
            examCenterLocationId: input.examCenterLocationId,
            remark: input.remark,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries: [SearchExamCenterLocationsUsageDocument, SearchExamCenterRoomsDocument],
      });
    },
    [revokeExamCenterLocationById],
  );

  return [revoke, { loading: revokeLoading, error }] as const;
}
